<template>
  <div class="trip-registration-body-wrapper">
    <div class="trip-registration-body">
      <label for="#" class="trip-registration-body__label"
             @click="setModelValue(false)"
             :class="componentModelValue ? '' : 'trip-registration-body__label--choose'">
        Я покупаю
      </label>
      <image-switch v-model="componentModelValue"
                    falseImg=""
                    trueImg=""
                    height="100%"
                    width="6rem"
                    trueMarkerImgSize="70%"
                    :falseMarkerImg="require('@/assets/img/misc/success-pic-bg-empty-green.svg')"
                    :trueMarkerImg="require('@/assets/img/misc/gift-pic.svg')"
                    trueMarkerColor="#fff"
                    falseMarkerColor="#fff"
                    falseBGColor="var(--prime-color)"
                    trueBGColor="linear-gradient(94.11deg, #FC9C97 7.37%, #FFAC7E 100%)">
      </image-switch>
      <label for="#" class="trip-registration-body__label"
             @click="setModelValue(true)"
             :class="componentModelValue ? 'trip-registration-body__label--choose' : ''">
        Я дарю
      </label>
    </div>
  </div>
</template>

<script>
import ImageSwitch from '@/components/UI/ImageSwitch'

export default {
  name: "TripRegistration",

  components: {
    ImageSwitch
  },

  model: {
    prop: "modelValue",
    event: "change"
  },

  props: {
    modelValue: {
      type: Boolean,
    }
  },

  computed: {
    componentModelValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.modelValue = value;
        this.$emit("change", this.modelValue);
      },
    }
  },

  methods: {
    setModelValue(value) {
      this.componentModelValue = value;
    },
  },
};
</script>

<style scoped>
.trip-registration-body-wrapper {}

.trip-registration-body {
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  align-items: center;
  height: 2.5em;
}

.trip-registration-body__label {
  cursor: pointer;
  transition: .3s;
}

.trip-registration-body__label--choose {
  font-weight: bold;
}

@media screen and (max-width: var(--mobile-breakpoint)) {
  .trip-registration-body-wrapper {
    justify-content: center;
    display: flex;
  }
}
</style>
